import script from "./ScrollerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollerModal.vue?vue&type=script&setup=true&lang=js"

import "./ScrollerModal.vue?vue&type=style&index=0&id=14b590b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b590b9"]])

export default __exports__